export enum PlayTypes {
  SCENE = 'Scene',
  GROUP_OBJECT = 'GroupObject',
  VIDEO = 'Video',
  SEQUENCE = 'Sequence',
  IMAGE = 'Image',
  HOTSPOT = 'Hotspot',
  FONT = 'Font',
  GAME = 'Game',
}

export default PlayTypes;
